import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

interface LabelTooltipProps {
  hoverItem?: any;
  tipBody?: string;
  placement?: "top-start" | "top" | "top-end" | "left-start" | "left" | "left-end" | "right-start" | "right" | "right-end" | "bottom-start" | "bottom" | "bottom-end"
}

const useStylesBootstrap = makeStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.grey[900],
    boxShadow: theme.shadows[5],
    color: "#fff"
  },
}));

function InformationTooltip(props) {
  const classes = useStylesBootstrap();
  return <Tooltip classes={classes} {...props} />;
}

const LabelTooltip: React.FC<LabelTooltipProps> = ({
  hoverItem,
  tipBody,
  placement
}) => {
  return (
    <InformationTooltip title={tipBody} placement={placement || "top"} >
        {hoverItem}
    </InformationTooltip>
  );
};

export default LabelTooltip;